import React, { useState } from "react"


import { errorJsonHasErrors } from "./Input_Fns"
import { set } from "lodash"
import { InputSelect1 } from "./Select"
import { useEffect } from "react"
import { Arrayify } from "../../Functions/utils"


const itemReplacer = (array, oldItem, newItem) => {
    return Arrayify(array).map(item => item === oldItem ? newItem : item);
}

export const emptySelect = "--none--*";

export const emptyselectReplacer = (set) => {
    return itemReplacer(set, "", emptySelect)
}

export const emptySelectDisplay = (v) => {
    return (v === "" ? emptySelect : v)
}



export const emptySelectStore = (v) => {
    let x = v === emptySelect ? "" : v
    return x
}

export const InputAccountTypeName = ({
    avail, inputForm, onChange,
    MenuProps,
    width = 220,
    maxwidth = 300,

    onError,
    both_allowed = false,
    none_allowed = false,
    doValidation,
}) => {
    const [form, setForm] = useState({ name: inputForm.AccountName, type: inputForm.AccountType })
    const [errors, setErrors] = useState({})

    const emptySelectDisplay_ = (v, array, name) => {

        if (v === "") {
            return emptySelect
        } else if (Arrayify(array).includes(v)) {
            return v
        }
        let nf = onChange_any(name, "")
        validation(nf)
        return emptySelect
    }


    const onChange_any = (n, v) => {
        console.log(form);
        let nf = {
            ...form,
            [n]: v,
        };
        console.log(nf);
        setForm(nf)
        onChange(nf.name, nf.type);
        return nf
    };



    const onChange_t = (e) => {
        let v = emptySelectStore(e.target.value)
        console.log(e.target.name);
        console.log(v);
        let nf = onChange_any(e.target.name, v);
        validation(nf)
    };

    const validation = (f) => {
        let ne = structuredClone(errors)

        let errNames = ""
        let errTypes = ""
        console.log(f)



        if (f.name === "" &&
            f.type === "") {
            if (!none_allowed) {
                errNames = "Please enter a name or type"
                errTypes = errNames
            }
        } else {
            if ((!both_allowed) && (f.name !== "" && f.type !== "")) {
                errNames = "Please enter only a name or a type"
                errTypes = errNames
            }
        }


        ne = set(ne, "name", errNames)
        ne = set(ne, "type", errTypes)
        console.log("onBlur acc Names/Types")
        console.log(errNames)
        setErrors(ne)
        if (onError !== null) {
            onError(errorJsonHasErrors(ne) ? "Errors" : "")
        }

    }



    useEffect(() => {
        validation(form)
    }, [doValidation])

    return (
        <>
            <InputSelect1
                label="Accounts"
                name="name"
                value={emptySelectDisplay_(form.name, avail.AccountNames, "name")}
                onChange={onChange_t}
                minWidth={width}
                maxWidth={maxwidth}
                errors={errors}
                avail={emptyselectReplacer(avail.AccountNames)}
                MenuProps={MenuProps}
            />
            <InputSelect1
                label="Account Types"
                name="type"
                value={emptySelectDisplay_(form.type, avail.AccountTypes, "type")}
                onChange={onChange_t}
                minWidth={width}
                maxWidth={maxwidth}
                errors={errors}
                avail={emptyselectReplacer(avail.AccountTypes)}
                MenuProps={MenuProps}
            />

            {/* this is an extra field that will run on focus/blur to ensure that we can ccheck the onError condition */}

        </>

    )
}

